import React from 'react';
import { Control } from 'react-hook-form';
import { Button } from '@zurich-primitives/button';
import useInputGeneratorLabels from '../hooks/useInputGeneratorLabels';
import useInputGeneratorFields from '../hooks/useInputGeneratorFields';
import { AutocompleteControlledInput } from './autocompleteControlledInput';
import { FormFields } from '../IGPRScore.interface';

interface InputMedicationProps {
  control: Control<FormFields>;
}

const fieldArrayName = 'medications';
export const InputMedication: React.FC<InputMedicationProps> = ({
  control
}) => {
  const labelText = useInputGeneratorLabels(fieldArrayName);

  const { fields, append } = useInputGeneratorFields(control, fieldArrayName);

  return (
    <section id="medication-input">
      <h2 className="h2">{labelText}</h2>
      <div className="py-5">
        {fields.map((field, index) => (
          <AutocompleteControlledInput
            key={field.id}
            control={control}
            name={`${fieldArrayName}.${index}.value`}
            placeholder={labelText}
          />
        ))}
      </div>

      <Button
        className="body-sm-r"
        variant="tertiary"
        onClick={() => append({ value: '' })}
      >
        <Button.Label>+ Add</Button.Label>
      </Button>
    </section>
  );
};

export default InputMedication;
